import { Player } from '@lottiefiles/react-lottie-player';
import { Check, Close, TaskAlt } from '@mui/icons-material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { List, ListItem, Stack, StepButton, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/system';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import jobAnimation from "../../assets/software-development.json";
import { pages } from '../../consts/types/pages';
import { UserProfileParts } from '../../consts/types/user';
import AppBarComp from '../AppBarComp';


interface UserIntroProps {

}

type Props = UserIntroProps;


const UserIntro: FC<Props> = (props: Props) => {
    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate();
    const theme = useTheme();
    const maxSteps = UserProfileParts.length;
    // const isUpXS = useMediaQuery(theme.breakpoints.up('xs'));
    const isUpMD = useMediaQuery(theme.breakpoints.up('md'));
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStep = (step: number) => () => {
        setActiveStep(step);
    };
    return <Box >
        <AppBarComp />
        <Box pt={4} pb={8} display={{ xs: "none", md: "block" }}>
            <Container maxWidth="xl" >
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box pl={4}>
                        <Typography width={"100%"} fontWeight={700} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.2rem" }} mb={3}>
                            Start your next job.
                        </Typography>

                        <Box sx={{ display: "flex", width: "100%" }} mb={3}>
                            <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="greenyellow">
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>We offer a</Typography>
                            </Box>
                            <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="greenyellow">
                                <Check color='inherit' />
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Smart</Typography>
                            </Box>
                            <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="#46edffff">
                                <Check color='inherit' />
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Easy</Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center" }} color="orange">
                                <Check color='inherit' />
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Time Saving</Typography>
                            </Box>

                        </Box>
                        <Typography width={"100%"} fontWeight={400} fontSize={{ xs: "1.2rem", md: "1.5rem" }} mb={1}>
                            platform designed to <strong>match</strong> Hig Tech job seekers and employers
                        </Typography>
                        <Typography width={"100%"} fontWeight={400} fontSize={{ xs: "1.2rem", md: "1.5rem" }} mb={1}>
                            based on details that are collected from both parties
                        </Typography>
                        <Typography width={"100%"} fontWeight={400} fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                            in order to make the most reliable and <strong>accurate</strong> match.
                        </Typography>
                        <Box mt={6} >
                            <Button variant="outlined" sx={{ borderRadius: "50px" }} color="primary" onClick={() => { navigate("/user") }}>Go To Dashboard ➔</Button>
                        </Box>
                    </Box>
                    <Box display="flex">
                        <Player
                            speed={0.5}
                            loop={true}
                            autoplay
                            src={jobAnimation}
                            rendererSettings={{
                                preserveAspectRatio: 'xMidYMid meet',
                            }}
                            style={{ height: "50vh", }}
                        />
                    </Box>
                </Box>
            </Container>
        </Box>
        <Box pt={4} pb={6} display={{ xs: "block", md: "none" }}>
            <Container maxWidth="xl" >
                <Typography align="center" width={"100%"} fontWeight={700} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.2rem" }} mb={2}>
                    Start your next job.
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center" }} mb={2}>
                    <Typography fontSize={{ xs: "1rem", md: "1.5rem" }} fontWeight={500} color="#20264a" >Our solution is a</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }} mb={3}>

                    <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="greenyellow">
                        <Check color='inherit' />
                        <Typography fontSize={{ xs: "0.875rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Smart</Typography>
                    </Box>
                    <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="#46edffff">
                        <Check color='inherit' />
                        <Typography fontSize={{ xs: "0.875rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Easy</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }} color="orange">
                        <Check color='inherit' />
                        <Typography fontSize={{ xs: "0.875rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Time Saving</Typography>
                    </Box>

                </Box>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    platform designed to <strong>match</strong> Hig Tech
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    job seekers and employers
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} mt={1}>
                    based on details that are
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    collected from both parties
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} mt={1}>
                    in order to make the most reliable
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    and <strong>accurate</strong> match.
                </Typography>

                <Box mt={4} textAlign="center">
                    <Button variant="outlined" sx={{ borderRadius: "50px" }} color="primary" onClick={() => { navigate("/user") }}>Go To Dashboard ➔</Button>
                </Box>
            </Container>
        </Box>
        <Box pt={5} pb={8} sx={{ background: "#edf7fe" }}>
            <Container maxWidth="lg" >
                <Typography align="center" width={"100%"} fontWeight={400} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.2rem" }} mb={6}>
                    How it works?
                </Typography>
                <Box display="flex" gap={{ xs: 2, md: 3 }} flexDirection={{ xs: "column", md: "row" }}>
                    <Box flex={1}>
                        <Box display="flex" gap={2} mb={2} >
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                <strong>1</strong>
                            </Typography>
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} width="100%" color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                Candidates fill in their information.
                            </Typography>
                        </Box>
                        <Box display="flex" mb={{ xs: 0, md: 4 }} >
                            <Stepper nonLinear orientation='vertical' activeStep={activeStep} sx={{ display: { xs: "none", md: "flex" }, flex: 0.4, padding: 3, background: "#dff2ff" }}>
                                {UserProfileParts.map((step, index) => (
                                    <Step key={step.label}>
                                        <StepButton color="inherit" onClick={handleStep(index)}>
                                            {step.label}
                                        </StepButton>
                                    </Step>
                                ))}
                            </Stepper>

                            <Box flexDirection="column" alignItems="center" padding={3} flex={1}>
                                <Typography fontSize={{ xs: "1.1rem", md: "1.3rem" }} fontWeight={500} textAlign="center" mb={1}>{UserProfileParts[activeStep].label}</Typography>
                                <Typography fontSize={{ xs: "1rem", md: "1.1rem" }} textAlign="center" >{UserProfileParts[activeStep].description}</Typography>
                                {/* <Typography fontSize={{ xs: "1rem", md: "1.1rem" }} textAlign="center" color="slategray">{UserProfileParts[activeStep].subDescription || " "}</Typography> */}
                                <Player
                                    loop
                                    autoplay
                                    src={UserProfileParts[activeStep].animation as any}
                                    rendererSettings={{
                                        preserveAspectRatio: 'xMidYMid meet',
                                    }}
                                    style={{ height: "25vh", marginTop: "16px" }}
                                />
                            </Box>
                        </Box>
                        {/* Mobile */}
                        <MobileStepper
                            sx={{ display: { xs: "flex", md: "none" }, px: 8, mb: 4, background: "transparent" }}
                            variant="text"
                            steps={maxSteps}
                            position="static"
                            activeStep={activeStep}
                            nextButton={
                                <Button
                                    size="small"
                                    onClick={handleNext}
                                    disabled={activeStep === maxSteps - 1}
                                >
                                    Next
                                    <KeyboardArrowRight />
                                </Button>
                            }
                            backButton={
                                <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                                    <KeyboardArrowLeft />
                                    Back
                                </Button>
                            }
                        />
                        {/* <Box display="flex" justifyContent="center">
                    <KeyboardDoubleArrowDownOutlined fontSize='large' sx={{ mb: 2 }} />
                </Box> */}
                    </Box>
                    <Box flex={1}>
                        <Box display="flex" gap={2} >
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                <strong>2</strong>
                            </Typography>
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} width="100%" color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                Employers fill in job requirements. Skills, experience years and more.
                            </Typography>
                        </Box>
                        <Box display="flex" gap={2} mt={{ xs: 3, md: 8 }}>
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                <strong>3</strong>
                            </Typography>
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} width="100%" color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                Our algorithm matches candidates to job specifications.
                            </Typography>
                        </Box>
                        <Box display="flex" gap={2} mt={{ xs: 3, md: 8 }}>
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                <strong>4</strong>
                            </Typography>
                            <Typography align={isUpMD ? "left" : "center"} fontWeight={400} width="100%" color="primary" fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                                Employers get a list of candidates and their contact information.</Typography>
                        </Box>
                    </Box>
                </Box>
                <Box justifyContent="center" display="flex" mt={{ xs: 7, md: 0 }}>
                    <Button variant="contained" sx={{ borderRadius: "50px" }} color="primary" onClick={() => { navigate("/user") }}>GET STARTED</Button>
                </Box>
            </Container>
        </Box>
        <Box pt={5} pb={8} sx={{ background: "#084c9d", color: "white" }}>
            <Container maxWidth="lg" >
                <Typography align="center" width={"100%"} fontWeight={400} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.2rem" }} mb={3}>
                    Time Saving Process
                </Typography>
                <Box display="flex" justifyContent="space-between" flexWrap='wrap' mt={6} gap={4}>
                    <Box mb={2}>
                        <Typography fontSize={{ xs: "1.5rem", md: "2.2rem" }} fontWeight={700} color="#e7ffdd" mb={1}>Our Solution</Typography>
                        <Stack spacing={2} >
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>Create a <u>full</u> profile just once
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>
                                    No jobs searching! Profile is <u>matched</u> to the
                                    <Typography component={isUpMD ? "div" : "span"} fontSize="inherit" fontWeight="inherit"> most relevant employers <u>automatically</u></Typography>
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>
                                    Increased chances to get noticed. The more
                                    <Typography component={isUpMD ? "div" : "span"} fontSize="inherit" fontWeight="inherit"> information you provide the better matches you get</Typography>
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>
                                    Equal chances for all, no networking profiles or CVs
                                </Typography>

                            </ListItem>
                        </Stack>
                    </Box>
                    <Box mb={2}>
                        <Typography fontSize={{ xs: "1.5rem", md: "2.2rem" }} fontWeight={700} color="#ffebdd" mb={1}>No more</Typography>
                        <Stack spacing={2} >
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>Preparing CV documents, which
                                    <Typography fontSize="inherit" fontWeight="inherit" component={isUpMD ? "div" : "span"}> not always look the best</Typography>
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>
                                    Wasting time scanning tens of job offers,
                                    <Typography component={isUpMD ? "div" : "span"} fontSize="inherit" fontWeight="inherit"> without knowing what is relevant</Typography>
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>
                                    Being ignored by recruiters
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>Building social profiles </Typography>
                            </ListItem>
                        </Stack>
                    </Box>
                </Box>
            </Container>
        </Box>
        {/* Footer */}
        <Box sx={{
            minHeight: "20vh",
            backgroundColor: "#20264a",
            py: 5
        }}>
            <Container maxWidth="xl">
                <List >
                    {pages.map(page => <ListItem disableGutters key={page.name} >
                        <Link to={page.url} color="white" style={{ textDecoration: "none" }}>
                            <Typography color="lightgray" sx={{ textDecoration: "none" }}>{page.name}</Typography>

                        </Link>
                    </ListItem>)}
                    <ListItem disableGutters>
                        <Typography color="lightgray" sx={{ textDecoration: "none" }}>
                            Contact us at <u><a style={{ color: "lightgray" }} href="mailto:tik.tech.job@gmail.com">tik.tech.job@gmail.com</a></u>
                        </Typography>
                    </ListItem>
                </List>
            </Container>
        </Box>
    </Box>
}


export default UserIntro;

